<template>
  <div v-if="show" class="card shadow position-fixed border border-primary w-25 popover disabled-action"
    :style="{ left: box.left + 'px', top: box.top + 'px' }">
    <div class="card-body p-2">
      <div class="small text-muted">{{ box.timeText }}</div>
      <div class="h4 mb-2">{{ box.close }}</div>
      <div class="d-flex">
        <div class="mr-3">
          <div class="text-muted small">VOLUME</div>
          <div class="font-weight-bold">{{ box.volume }}</div>
        </div>
        <div class="ml-auto">
          <div class="small text-muted">
            OPEN: <span class="text-dark font-weight-bold">{{ box.open }}</span>
          </div>
          <div class="small text-muted">
            CLOSE: <span class="text-dark font-weight-bold">{{ box.close }}</span>
          </div>
          <div class="small text-muted">
            HIGH: <span class="text-dark font-weight-bold">{{ box.high }}</span>
          </div>
          <div class="small text-muted">
            LOW: <span class="text-dark font-weight-bold">{{ box.low }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChartInfoCard",
  props: {
    show: { type: Boolean, default: false },
    box: { type: Object, required: true },
  },
};
</script>
